export default __webpack_public_path__ + "static/media/garanty.ee6e9b49.webp";